import { RequestedProblem } from "../types/Problem";

export function groupProblemsByDate(problems) {
	for (const problem of problems) {
		if (problem.last_submitted_at && problem.last_submitted_at.seconds) {
			problem.last_submitted_at._seconds =
				problem.last_submitted_at.seconds;
		}
	}

	problems = problems.filter((problem) => {
		if (!problem.last_submitted_at || !problem.last_submitted_at._seconds) {
			return false;
		}
		return true;
	});

	problems.sort((p1, p2) => {
		if (p1.last_submitted_at._seconds <= p2.last_submitted_at._seconds) {
			return 1;
		} else {
			return -1;
		}
	});

	for (const problem of problems) {
		const date = new Date(problem.last_submitted_at._seconds * 1000);
		problem.last_submitted_at = {
			year: date.getFullYear(),
			month: date.getMonth() + 1,
			day: date.getDate(),
			hour: date.getHours(),
			minute: date.getMinutes(),
		};
	}

	const groupedProblems = [];
	for (const problem of problems) {
		if (
			groupedProblems.length === 0 ||
			groupedProblems[groupedProblems.length - 1][0].last_submitted_at
				.year !== problem.last_submitted_at.year ||
			groupedProblems[groupedProblems.length - 1][0].last_submitted_at
				.month !== problem.last_submitted_at.month ||
			groupedProblems[groupedProblems.length - 1][0].last_submitted_at
				.day !== problem.last_submitted_at.day
		) {
			groupedProblems.push([problem]);
		} else {
			groupedProblems[groupedProblems.length - 1].push(problem);
		}
	}
	return groupedProblems;
}
